import { HttpClient, HttpBackend } from "@angular/common/http";
import { Injectable, Injector, inject } from "@angular/core";
import { Observable } from "rxjs";

export interface SentryGlobalConfig {
    dsn: string;
    enabled: boolean;
    environment: string;
    tenant: string;
    tracesSampleRate: number;
    // Local-dev only: when true, stream telemetry to the Spotlight sidecar at spotlightUrl instead
    // of sentry.io, so nothing leaves the box. Set by the backend running in Spotlight mode.
    spotlight: boolean;
    spotlightUrl: string;
}

export interface SentryUserConfig {
    userId: string;
    enableBugReporting: boolean;
}

@Injectable({
    providedIn: "root",
})
export class ObservabilityDataService {
    private getUserHttpClient: () => HttpClient;
    private getAnonymousHttpClient: () => HttpClient;

    public constructor() {
        const httpBackend = inject(HttpBackend);
        const injector = inject(Injector);

        this.getAnonymousHttpClient = () => new HttpClient(httpBackend);
        this.getUserHttpClient = () => injector.get(HttpClient);
    }

    public getGlobalConfig(): Observable<SentryGlobalConfig> {
        return this.getAnonymousHttpClient().get<SentryGlobalConfig>("api/sentry/config");
    }

    public getUserConfig(): Observable<SentryUserConfig> {
        return this.getUserHttpClient().get<SentryUserConfig>("api/sentry/config/user");
    }
}